import styled from 'styled-components';
import { View, Theme, themeHelpers } from '@acin/ui-core';

const { pageBackground } = themeHelpers;

export const ChooseDocument = styled(View)<{ activeTheme: Theme }>`
  ${(p) => pageBackground(p.activeTheme)};
  padding: ${(p) => p.theme.spacing.getSize(6)};
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: 100%;
`;

export const LoadingWrapper = styled(View)`
  position: relative;
  height: 100%;
  margin: 0 auto;
  align-self: center;
  align-items: center;
  justify-content: center;
  display: flex;
`;
